import { ISearchParamsPagesState } from "./types";
import ActionTypes from "../../../constants/ActionTypes";

const initialState: ISearchParamsPagesState = {
  productList: {},
  productOverview: {},
  manhattan: {},
};

const searchParamsReducer = (
  state = initialState,
  action: any
): ISearchParamsPagesState => {
  switch (action.type) {
  case ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.SET:
    return {
      ...state,
      productList: action.payload.items,
    };
  case ActionTypes.SEARCH_PARAMS.PRODUCT_OVERVIEW.SET:
    return {
      ...state,
      productOverview: action.payload.items,
    };
  case ActionTypes.SEARCH_PARAMS.MANHATTAN.SET:
    return {
      ...state,
      manhattan: action.payload.items,
    };
  case ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.CLEAR:
    return {
      ...state,
      productList: {},
    };
  case ActionTypes.SEARCH_PARAMS.PRODUCT_OVERVIEW.CLEAR:
    return {
      ...state,
      productOverview: {},
    };
  case ActionTypes.SEARCH_PARAMS.MANHATTAN.CLEAR:
    return {
      ...state,
      manhattan: {},
    };
  }
  return state;
};

export default searchParamsReducer;
